import * as React from "react";
import { ReactNode, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setAppState } from "src/redux/features/appStateSlice";

type Props = {
  state?: string,
  children: ReactNode
};

/**
 * @function PageWrapper
 * @param {Props} props { state?: string, children: ReactNode }
 * @returns {React.JSX.Element}
 */
const PageWrapper = (props: Props): React.JSX.Element => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.state) {
      dispatch(setAppState(props.state));
    }
  }, [dispatch, props]);

  return (
    <>{props.children}</>
  );
};

export default PageWrapper;
